import {useMemo} from "react";
import {preferredFreightTypeIdSelector} from "../store/entity/service-type-freight-type-assoc/selectors";
import {useGetServiceTypeFreightTypeAssocsByServiceTypeQuery} from "../store/entity/service-type/service-type-store";
import {skipToken} from "@reduxjs/toolkit/query";

export type UseGetPreferredFreightTypeProps = {
  serviceTypeId?: string;
  regionId?: string;
}

export type UseGetPreferredFreightTypeResult = {
  freightTypeId?: string
}

export const useGetPreferredFreightType = (props: UseGetPreferredFreightTypeProps): UseGetPreferredFreightTypeResult => {
  const {serviceTypeId, regionId} = props;

  const selectPreferredFreightTypeId = useMemo(() => {
    return preferredFreightTypeIdSelector();
  }, []);

  const {freightTypeId} = useGetServiceTypeFreightTypeAssocsByServiceTypeQuery(serviceTypeId ? {
    serviceTypeId: serviceTypeId,
    regionId: regionId,
  } : skipToken, {
    selectFromResult: (result) => ({
      freightTypeId: selectPreferredFreightTypeId(result),
      isLoading: result.isLoading
    })
  });

  return {
    freightTypeId: freightTypeId
  };
};
